// extracted by mini-css-extract-plugin
export default {"photographArea":"yaQTDvUPmszN3a0t6rUJ","photoImg":"sYE3WBVOEtwAgFCKk8Zy","common_bganimation":"xK_3VIhOBZWYRYGCQTag"};